import React from "react";
import CreatorRevShareCampaignsTable from "./CreatorRevShareCampaignsTable";

interface TransactionsTabProps {
  creatorId: string;
}

/**
 * TransactionsTab Component
 *
 * Displays RevShare campaigns for the creator.
 * Uses the CreatorRevShareCampaignsTable component.
 */
const TransactionsTab: React.FC<TransactionsTabProps> = ({ creatorId }) => {
  return (
    <div className="space-y-4">
      <CreatorRevShareCampaignsTable creatorId={creatorId} />
    </div>
  );
};

export default TransactionsTab;
